<template>
  <div @click="goToSite()">
    <div
      :class="['deal-card', 'has-text-centered', isPromoted(deal.featured) ? 'promoted-deal-card' : 'unpromoted-deal-card']"
    >
      <h2 class="deal-title cardContent15">{{deal.name}}</h2>
      <div class="flex-center cardContent15" >
        <p class="tagline" v-if="deal.tagline">{{deal.tagline}}</p>
      </div>
      <div class="cardContent50">
        <p class="tagline">{{deal.description}}</p>
      </div>
      <div class="flex-center cardContent20">
        <div >
          <p class="price">{{deal.cost | formatPrice }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions(["addReferral"]),
    isPromoted(promoted) {
      return promoted
    },
    goToSite(){
      let website = this.website
      if (website.indexOf("http") === -1) {
        website = "http://" + website;
      }
      window.open(
        website,
        "_blank"
      );
      this.addReferral(this.$route.params.id)
    }
  },
  props: {
    deal: {
      type: Object,
      required: true
    },
    website:{
      type: String,
      required: true
    }
  }
};
</script>


<style lang="scss" scoped>

.deal-card {
  height: auto;
  cursor: pointer
}

.deal-title{
  font-size: calc(1.5rem + 0.5vw)
}
.tagline{
  font-size: calc(1rem + 0.5vw);
  padding: 0.5rem
}
.unpromoted-deal-card {
  .tagline {
    color: black;
  }
}

.cardContent15{
  min-height: 15%
}

.cardContent20{
  min-height: 20%
}

.cardContent50{
  min-height: 50%
}

@media only screen and (max-width: 770px){
  .deal-card{
    width: 90%;
    margin: 1rem auto;
    height:auto;
    background-color: white;
  }
  .promoted-deal-card{
    background-color: #00c5fd;
  }
}
</style>